var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"app-layout",class:{'app-layout--collpase': _vm.isCollapsed || _vm.appBreakpoint}},[_c('AppSider'),_c('Layout',{staticClass:"app-main"},[_c('AppHeader'),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('AppFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }